import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  IconButton,
} from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import styled from "styled-components";

import Button from "../button/Button";

const DialogHeader = styled(DialogTitle)`
  background: ${(props) => props.theme.greyBackground};

  &.dialog-header {
    padding: 10px 24px;
  }
`;

const DialogBody = styled(DialogContent)`
  padding: 24px !important;
`;

const StyledDialogActions = styled(DialogActions)`
  padding: 8px 18px 14px !important;
`;

export interface ConfirmationDialogProps extends DialogProps {
  title: string;
  cancelBtnText: string;
  confirmBtnText: string;
  isCancelDisabled?: boolean;
  isConfirmDisabled?: boolean;
  onConfirm(): void;
  onCancel(): void;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  title,
  cancelBtnText,
  confirmBtnText,
  isCancelDisabled,
  isConfirmDisabled,
  onConfirm,
  onCancel,
  children,
  maxWidth = "xs",
  ...extraProps
}) => {
  return (
    <Dialog
      {...extraProps}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={true}
      maxWidth={maxWidth}
    >
      <DialogHeader className="dialog-header">
        {title}
        <IconButton
          onClick={onCancel}
          aria-label="close-button"
          sx={{
            position: "absolute",
            right: 12,
            top: 6,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogHeader>
      <DialogBody>{children}</DialogBody>
      <StyledDialogActions>
        <Button
          variant="grey"
          disabled={isCancelDisabled}
          onClick={onCancel}
          aria-label="cancel"
        >
          {cancelBtnText}
        </Button>
        <Button
          variant="success"
          disabled={isConfirmDisabled}
          onClick={onConfirm}
          aria-label="confirm"
        >
          {confirmBtnText}
        </Button>
      </StyledDialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
